<template>
  <div class="store">
    <div class="container">
      <div>
        <Title />
        <div class="row justify-content-between">
          <Breadcrumb />
          <div class="col-12 col-sm text-end mb-3 mb-sm-0">
            <button
              type="button"
              class="btn btn-transparent me-3"
              @click="showModal(null)"
            >
              新增門市
            </button>
            <button type="button" @click="saveSort" class="btn btn-light">
              儲存排序
            </button>
          </div>
        </div>
      </div>
      <div class="card mb-3">
        <div class="card-body">
          <div class="table-responsive">
            <table class="table align-middle text-nowrap">
              <thead>
                <tr>
                  <th scope="col">排序</th>
                  <th scope="col">名稱</th>
                  <th scope="col">電話</th>
                  <th scope="col">信箱</th>
                  <th scope="col">地址</th>
                  <th scope="col">功能</th>
                </tr>
              </thead>
              <draggable
                tag="tbody"
                v-model="items"
                handle=".drag"
                group="form"
                animation="1000"
              >
                <tr v-for="table in items" :key="'table' + table.id">
                  <td class="drag text-center" style="cursor: all-scroll">
                    <i class="bi bi-arrows-move"></i>
                  </td>
                  <td>{{ table.name }}</td>
                  <td>{{ table.phone }}</td>
                  <td>{{ table.email }}</td>
                  <td>{{ table.address }}</td>
                  <td>
                    <div class="d-flex flex-nowrap flex align-items-center">
                      <button
                        @click="showModal(table.id)"
                        type="button"
                        class="btn btn-link px-1"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="編輯"
                      >
                        <i class="bi bi-pencil mx-1 fs-5"></i>
                      </button>
                      <button
                        v-if="table.id !== 3"
                        @click="showDeleteModal(table.id, table.name)"
                        type="button"
                        class="btn btn-link px-1 text-danger"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="刪除"
                      >
                        <i class="bi bi-trash me-2"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </draggable>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="storeModal"
      tabindex="-1"
      ref="storeModal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content" v-if="modalDate">
          <div class="modal-header">
            <h5 class="modal-title">{{ isEdit ? '編輯門市' : '新增門市' }}</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="save">
              <div class="row">
                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="modalName" class="form-label required"
                      >名稱</label
                    >
                    <input
                      v-model="modalDate.name"
                      type="text"
                      class="form-control"
                      id="modalName"
                      placeholder="請輸入"
                      required
                    />
                  </div>
                  <div class="mb-3">
                    <label for="modalPhone" class="form-label">電話</label>
                    <input
                      v-model="modalDate.phone"
                      type="text"
                      class="form-control"
                      id="modalPhone"
                      placeholder="請輸入"
                    />
                  </div>
                  <div class="mb-3">
                    <label for="modalEmail" class="form-label">信箱</label>
                    <input
                      v-model="modalDate.email"
                      type="email"
                      class="form-control"
                      id="modalEmail"
                      placeholder="請輸入"
                    />
                  </div>
                  <div class="mb-3">
                    <label for="modalBusinessHours" class="form-label"
                      >營業時間</label
                    >
                    <input
                      v-model="modalDate.business_hours"
                      type="text"
                      class="form-control"
                      id="modalBusinessHours"
                      placeholder="請輸入"
                    />
                  </div>
                  <div class="mb-3">
                    <label class="form-label required">選擇區域</label>
                    <select
                      class="form-select"
                      required
                      v-model="modalDate.zone"
                    >
                      <option :value="null">請選擇</option>
                      <option
                        v-for="(item, key, index) in zone"
                        :key="key + index"
                        :value="key"
                      >
                        {{ item }}
                      </option>
                    </select>
                  </div>
                  <div class="mb-3">
                    <label for="modalAddress" class="form-label required"
                      >完整地址</label
                    >
                    <input
                      v-model="modalDate.address"
                      type="text"
                      class="form-control"
                      id="modalAddress"
                      placeholder="請輸入"
                      required
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="modalGoogleMap" class="form-label required"
                      >Google Map Iframe</label
                    >
                    <textarea
                      v-model="modalDate.google_map"
                      class="form-control"
                      id="modalGoogleMap"
                      rows="3"
                      placeholder="請貼上Google Map Iframe"
                    ></textarea>
                  </div>
                  <div class="mb-3">
                    <label for="modalDescription" class="form-label"
                      >門市簡介</label
                    >
                    <textarea
                      v-model="modalDate.description"
                      class="form-control"
                      id="modalDescription"
                      rows="3"
                      placeholder="請輸入"
                    ></textarea>
                  </div>
                  <div class="mb-3">
                    <label for="modalNote" class="form-label">備註</label>
                    <textarea
                      v-model="modalDate.note"
                      class="form-control"
                      id="modalNote"
                      rows="3"
                      placeholder="請輸入"
                    ></textarea>
                  </div>
                </div>
              </div>
              <button ref="submit" type="submit" class="d-none"></button>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              取消
            </button>
            <button
              @click="$refs.submit.click()"
              type="button"
              class="btn btn-primary"
            >
              儲存
            </button>
          </div>
        </div>
      </div>
    </div>
    <DeleteModal
      name="門市"
      :deleteItem="deleteItem"
      @confirmDelete="deleteStore"
    />
  </div>
</template>

<script>
import { store } from '@/http/api/store.js'
import { mapState, mapMutations, mapGetters } from 'vuex'
import { Modal } from 'bootstrap'
import draggable from 'vuedraggable'
import Title from '@/components/layout/Title.vue'
import Breadcrumb from '@/components/layout/Breadcrumb.vue'
import DeleteModal from '@/components/modal/DeleteModal.vue'

const defaultModalDate = {
  zone: null,
  business_hours: null,
  description: null,
  note: null,
  google_map: null,
  name: null,
  phone: null,
  email: null,
  address: null
}

export default {
  name: 'Store',
  components: { draggable, Title, Breadcrumb, DeleteModal },
  data () {
    return {
      bootstrap_modal: null,
      deleteItem: '',
      errMsg: null,
      errMsgKey: {
        zone: '區域',
        business_hours: '營業時間',
        description: '門市簡介',
        note: '備註',
        google_map: 'Google Map Iframe',
        name: '名稱',
        phone: '電話',
        email: '信箱',
        address: '地址'
      },
      isEdit: false,
      items: null,
      modalID: null,
      modalDate: JSON.parse(JSON.stringify(defaultModalDate)),
      zone: {
        KEL: '基隆市',
        NTP: '新北市',
        TPE: '台北市',
        TYN: '桃園市',
        HSZ: '新竹縣',
        HSZC: '新竹市',
        ZMI: '苗栗市',
        ZMIC: '苗栗縣',
        TXG: '台中市',
        CHW: '彰化縣',
        CHWC: '彰化市',
        NTC: '南投市',
        NTCC: '南投縣',
        YUN: '雲林縣',
        CYI: '嘉義縣',
        CYIC: '嘉義市',
        TNN: '台南市',
        KHH: '高雄市',
        PIF: '屏東縣',
        PIFC: '屏東市',
        ILA: '宜蘭縣',
        ILAC: '宜蘭市',
        HUN: '花蓮縣',
        HUNC: '花蓮市',
        TTT: '台東市',
        TTTC: '台東縣',
        PEH: '澎湖縣',
        GNI: '綠島',
        KYD: '蘭嶼',
        KNH: '金門縣',
        MFK: '馬祖',
        LNN: '連江縣'
      }
    }
  },
  computed: {
    ...mapState(['token', 'windowWidth', 'breakpoints']),
    ...mapGetters(['errMsgInfo'])
  },
  watch: {
    'token.headers.Authorization': function (data) {
      if (data) {
        this.initialEvent()
      }
    },
    items () {
      this.$nextTick(() => this.InitBootstrapTooltip())
    }
  },
  methods: {
    ...mapMutations([
      'AlertsInfo',
      'Alerted',
      'InitBootstrapTooltip',
      'Loading',
      'Loaded',
      'SetRouterName',
      'SetErrMsg',
      'SetErrMsgKey',
      'ToggleDeleteModal'
    ]),
    createStore () {
      const vm = this
      store
        .create(vm.modalDate, vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.AlertsInfo({
              state: 'success',
              title: '成功',
              info: '創建資料成功'
            })
            vm.bootstrap_modal.hide()
            vm.getData()
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
          }
          vm.Alerted()
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    },
    deleteStore () {
      const vm = this
      store
        .delete(vm.modalID, vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.AlertsInfo({
              state: 'success',
              title: '成功',
              info: '刪除資料成功'
            })
            vm.ToggleDeleteModal(false)
            vm.getData()
          } else {
            vm.ToggleDeleteModal(false)
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
          }
          vm.Alerted()
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.ToggleDeleteModal(false)
          vm.Alerted()
          vm.Loaded()
        })
    },
    getData () {
      const vm = this
      vm.Loading()
      store
        .get('', vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.items = data.data.sort((a, b) => a.sort - b.sort)
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
            vm.Alerted()
          }
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    },
    getAnStore (id) {
      const vm = this
      return new Promise((resolve) => {
        store
          .get(id, vm.token)
          .then((res) => {
            const { data } = res
            if (res.status <= 201 && data.status === 'success') {
              resolve(data.data)
            } else {
              vm.SetErrMsg(data.errMsg)
              vm.AlertsInfo({
                state: 'error',
                title: '失敗 ' + res.status,
                info: vm.errMsgInfo
              })
              vm.Alerted()
              vm.Loaded()
            }
          })
          .catch((err) => {
            vm.SetErrMsg(err)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗',
              info: vm.errMsgInfo
            })
            vm.Alerted()
            vm.Loaded()
          })
      })
    },
    initialEvent () {
      const vm = this
      vm.getData()
    },
    async showModal (id) {
      const vm = this
      vm.modalID = id
      vm.bootstrap_modal = new Modal(vm.$refs.storeModal, {
        backdrop: 'static',
        keyboard: false
      })
      vm.isEdit = false
      if (!id) {
        vm.modalDate = JSON.parse(JSON.stringify(defaultModalDate))
        vm.bootstrap_modal.show()
        return
      }
      vm.isEdit = true
      vm.Loading()
      vm.modalDate = await vm.getAnStore(id)
      vm.bootstrap_modal.show()
      vm.Loaded()
    },
    showDeleteModal (id, title) {
      const vm = this
      vm.modalID = id
      vm.deleteItem = title
      vm.ToggleDeleteModal(true)
    },
    save () {
      const vm = this
      vm.Loading()
      if (vm.isEdit) {
        vm.updateStore()
        return
      }
      vm.createStore()
    },
    saveSort () {
      const vm = this
      const sort = []
      vm.items.forEach((item, index) => {
        sort.push({
          id: item.id,
          sort: index + 1
        })
      })
      vm.Loading()
      store
        .sort({ sort }, vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.AlertsInfo({
              state: 'success',
              title: '成功',
              info: '更新排序成功'
            })
            vm.getData()
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
          }
          vm.Alerted()
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    },
    updateStore () {
      const vm = this
      store
        .update(vm.modalID, vm.modalDate, vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.AlertsInfo({
              state: 'success',
              title: '成功',
              info: '更新資料成功'
            })
            vm.bootstrap_modal.hide()
            vm.getData()
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
          }
          vm.Alerted()
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    }
  },
  created () {
    const vm = this
    vm.SetRouterName(vm.$route.name)
    vm.SetErrMsgKey(vm.errMsgKey)
  },
  mounted () {
    const vm = this
    if (vm.token.headers.Authorization) {
      vm.initialEvent()
    }
  }
}
</script>
